var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"title"},[_vm._v("Przepraszamy, wystąpił błąd")]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn",style:({ background: _vm.$color }),attrs:{"href":("tel:" + _vm.$phone)}},[_vm._v("Telefon")]),_vm._v(" "),_c('button',{staticClass:"btn",style:({ background: _vm.$color }),attrs:{"type":"button"},on:{"click":_vm.setHomePage}},[_vm._v("MENU")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bde0cc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistance_steps/DataSentError.vue
// module id = 221
// module chunks = 0